import React from 'react'
import { Button, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import styles from './ButtonStyles'

const WideButton = (props) => {
  const {
    buttonStyle = 'button_primary',
    label = '',
    fontStyle = {},
    sx = {},
    ...buttonProps
  } = props
  const classes = styles()
  return (
    <Button
      disableRipple
      disableTouchRipple
      variant="contained"
      type="primary"
      {...buttonProps}
      className={`${classes.wideButton} ${classes[buttonStyle]}`}
      sx={{ ...sx }}
    >
      <Typography sx={{ ...fontStyle, fontWeight: 700 }}>{label}</Typography>
    </Button>
  )
}

WideButton.propTypes = {
  buttonStyle: PropTypes.string,
  fontStyle: PropTypes.any,
  label: PropTypes.any,
  sx: PropTypes.any,
}

export default WideButton
